<template>
    <v-card class="pa-3 ma-md-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de contratos</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-contrato` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo contrato</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
                <v-checkbox
                    v-model="filtros.validacion"
                    label="Pendientes por validación"
                ></v-checkbox>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="Contratos"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            :item-class="getRowClass"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.status="{ item }">
                <span>{{
                    item.id_estado == 1
                        ? "En curso"
                        : item.id_estado == 2
                        ? "Finalizado"
                        : item.id_estado == 3
                        ? "Pausado"
                        : "Cancelado"
                }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a :href="item.pdf">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>
<!--             <template v-slot:item.pdf="{ item }">
                <a target="_blank" :href="`/api/pdf-contrato/${item.id}`">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template> -->
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ path: `/guardar-contrato?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
export default {
    data() {
        return {
            search: "",
            filtros: {
                validacion: 0,
            },
            headers: [
                { text: "Contrato", value: "id", sortable: false },
                {
                    text: "Cliente",
                    value: "cliente.razon_social",
                    sortable: false,
                },
                { text: "Fecha", value: "fecha", sortable: false },
                { 
                    text: "Estado planificación",
                    value: "EstadoA",
                    sortable: false,
                },
                { text: "Estado", value: "status", sortable: false },

                { text: "PDF", value: "pdf", sortable: false },

                { text: "Acciones", value: "action", sortable: false },
            ],
            Contratos: [],
            selectedItem: 0,
            dialog: false,
        };
    },
    created() {
        this.getContratos();
    },
    watch: {
        "filtros.validacion": function (val) {
            this.getContratos();
        },
    },
    methods: {
        getRowClass(item) {
            if (item.revisado == 0) {
                return "row_red";
            }
        },
        getContratos() {
            axios
                .get(
                    `api/get-contratos?validacion=${
                        this.filtros.validacion ? 1 : 0
                    }&nofilter=true`
                )
                .then(
                    (res) => {
                        this.Contratos = res.data.Contratos;
                    },
                    (err) => {
                        this.$custom_error("Error consultando los contratos");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Contratos.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-contrato", {
                    id: this.Contratos[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Contrato eliminado con éxito");
                        this.dialog = false;
                        this.getContratos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el contrato");
                    }
                );
        },
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
